/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { RXQuestionContentReplySuggestionType } from "./RXQuestionContentReplySuggestionType";

export interface RXQuestionContent {
  next_question?: string | null;
  reply_suggestion_type?: RXQuestionContentReplySuggestionType;
  reply_suggestions?: string[];
  question_hint?: string;
  screening_complete?: boolean;
}
